(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService', 'PackageFeatureListCustom', 'CompanyInfoQuery', '$localStorage'];

    function Principal($q, Account, JhiTrackerService, PackageFeatureListCustom, CompanyInfoQuery, $localStorage) {
        var _identity,
            _authenticated = false;

        var _company = null;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getCurrentCompany: getCurrentCompany,
            setCurrentCompany: setCurrentCompany,
            getCurrentCompanyFeatureList: getCurrentCompanyFeatureList,
            hasSpecialFeatureAccess: hasSpecialFeatureAccess,
            canAddNewServant: canAddNewServant,
            setCurrentCompanyFeatureList: setCurrentCompanyFeatureList
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {

            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function getCurrentCompany() {
            return _company;
        }

        function setCurrentCompany(company) {
            return _company = company;
        }

        function getCurrentCompanyFeatureList() {

            console.log("NEW VERSION !!! lastCompanyFeatureCheck : " + $localStorage.lastCompanyFeatureCheck);


            var lastCheck = getTimeStamp();
            if (!$localStorage.lastCompanyFeatureCheck)
                $localStorage.lastCompanyFeatureCheck = lastCheck;

            if ($localStorage.companyFeatureList != undefined && !lastCheckExpired()) {
                console.log($localStorage.companyFeatureList.featureInfoObject);
                return $localStorage.companyFeatureList;
            } else {
                PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                    setCurrentCompanyFeatureList(result);
                    $localStorage.lastCompanyFeatureCheck = lastCheck;
                    return result;
                });
            }

        }

        function setCurrentCompanyFeatureList(featureList) {
            return $localStorage.companyFeatureList = featureList;
        }


        function hasSpecialFeatureAccess(feature) {

            console.log("hasSpecialFeatureAccess Checking . . . ");

            if (!$localStorage.companyFeatureList) {
                return false;
            }

            if (!$localStorage.companyFeatureList.featureInfoObject)
                return false;


            var _companyFeatureList = $localStorage.companyFeatureList;

            console.log("_companyFeatureList : ");
            console.log(_companyFeatureList.featureInfoObject);

            switch (feature) {

                case 'twoStepVerification':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.twoStepVerification)
                        return true;
                    break;
                case 'satisfactionMessage_SMS':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_SMS)
                        return true;
                    break;
                case 'satisfactionMessage_Email':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_Email)
                        return true;
                    break;
                case 'cancelReserveByCustomer':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.cancelReserveByCustomer)
                        return true;
                    break;
                case 'autoMultiReserveMode':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.autoMultiReserveMode)
                        return true;
                    break;
                case 'couponCode':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.couponCode)
                        return true;
                    break;
                case 'customerGroup':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerGroup)
                        return true;
                    break;
                case 'customerAccess':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerAccess)
                        return true;
                    break;
                case 'reservePattern':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.reservePattern)
                        return true;
                    break;
                case 'customPricingForServant':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customPricingForServant)
                        return true;
                    break;
                case 'reserveLimit':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.reserveLimit)
                        return true;
                    break;
                case 'customerRebookReminder_SMS':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerRebookReminder_SMS)
                        return true;
                    break;
                case 'customerSecondReminder':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerSecondReminder)
                        return true;
                    break;
                case 'advancedPricing':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.advancedPricing)
                        return true;
                    break;
                case 'whatsAppSupport':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.whatsAppSupport)
                        return true;
                    break;
                case 'servantServiceScheduling':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.servantServiceScheduling)
                        return true;
                    break;
                case 'serviceCapacity':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.serviceCapacity)
                        return true;
                    break;
                case 'invoice':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.invoice)
                        return true;
                    break;
                case 'marketingCampaign':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.marketingCampaign)
                        return true;
                    break;


            }

            return false;
        }

        function canAddNewServant(count) {
            if (!$localStorage.companyFeatureList || !$localStorage.companyFeatureList.featureInfoObject) {
                // getCurrentCompanyFeatureList();
                // if(!_companyFeatureList)
                if (count >= 2)
                    return false;
                else
                    return true;
            }

            if ($localStorage.companyFeatureList.featureInfoObject) {
                if ($localStorage.companyFeatureList.featureInfoObject.servantCount) {
                    if ($localStorage.companyFeatureList.featureInfoObject.servantCount <= count)
                        return false;
                }
            }

            return true;
        }

        function getTimeStamp() {
            var now = new Date();
            var stampMinute = Math.ceil(now.getTime() / 60000);
            return stampMinute;
        }

        function lastCheckExpired() {
            if (!$localStorage.lastCompanyFeatureCheck)
                return false;

            var now = getTimeStamp();
            if (now - $localStorage.lastCompanyFeatureCheck > 2)
                return true;

            return false;
        }

    }
})();
